// Helpers to keep a Web Audio drone audible with the screen locked.

// Plays the node through an <audio> element (treated as media playback by mobile OSes).
// Falls back to the normal destination if the element cannot play.
export function routeToMediaElement(ctx, node) {
  if (navigator.audioSession) {
    try { navigator.audioSession.type = 'playback'; } catch { /* unsupported */ }
  }
  if (!ctx.createMediaStreamDestination) { node.connect(ctx.destination); return null; }
  const dest = ctx.createMediaStreamDestination();
  node.connect(dest);
  const el = new Audio();
  el.setAttribute('playsinline', '');
  el.srcObject = dest.stream;
  el.play().catch(() => { node.disconnect(dest); node.connect(ctx.destination); });
  return el;
}

export function setMediaSession({ title, artist, onStop }) {
  const ms = navigator.mediaSession;
  if (!ms) return;
  try {
    if (window.MediaMetadata) ms.metadata = new window.MediaMetadata({ title, artist, artwork: [{ src: '/icon-512.png', sizes: '512x512', type: 'image/png' }] });
    ['pause', 'stop'].forEach((a) => { try { ms.setActionHandler(a, onStop); } catch { /* unsupported action */ } });
    ms.playbackState = 'playing';
  } catch { /* ignore */ }
}

export function clearMediaSession() {
  const ms = navigator.mediaSession;
  if (!ms) return;
  try {
    ['pause', 'stop'].forEach((a) => { try { ms.setActionHandler(a, null); } catch { /* unsupported action */ } });
    ms.playbackState = 'none';
    ms.metadata = null;
  } catch { /* ignore */ }
}
